import { useNavigate, useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import {
  useGetAllPropertyMappingsForFeatureLine,
  useGetFeatureLineSetting,
  useUpdatePropertyMappingsForFeatureLine,
} from '../../../hooks/api/use-arcgis-civil3d-feature-line-settings.hook';
import {
  ArcgisCivil3dFeatureLineSettingApiModel,
  ArcgisCivil3dFeatureLineSettingRelationship,
} from '../../../../../types/models/arcgis-civil3d-feature-line-setting.model';
import { PropertyMappings } from './PropertyMappings';
import { LoadingIndicator } from '../../LoadingIndicator';
import { Civil3dFeatureTypeCategory } from '../../../../../types/constants/civil3d-feature-type';
import { WithConfiguration } from '../../../../../types/models/arcgis-civil3d-setting.model';

export const FeatureLinePropertyMappings = () => {
  const navigate = useNavigate();
  const { featureLineId } = useParams<{ featureLineId: string }>();

  const [updatePropertyMappings, { error: updatePropertyMappingsError }] = useUpdatePropertyMappingsForFeatureLine();
  const {
    featureLine,
    loading: loadingFeatureLine,
    error: getFeatureLineError,
  } = useGetFeatureLineSetting<ArcgisCivil3dFeatureLineSettingApiModel & WithConfiguration>({
    featureLineId: Number(featureLineId),
    include: [ArcgisCivil3dFeatureLineSettingRelationship.CONFIGURATION],
  });
  const {
    propertyMappings,
    loading: loadingPropertyMappings,
    error: propertyMappingsError,
  } = useGetAllPropertyMappingsForFeatureLine({
    featureLineId: Number(featureLineId),
  });
  const error = getFeatureLineError || propertyMappingsError || updatePropertyMappingsError;
  if (error || propertyMappingsError) {
    return <Alert severity="error">{(error || propertyMappingsError)?.response?.data.message}</Alert>;
  }

  return loadingFeatureLine || loadingPropertyMappings || !featureLine || !propertyMappings ? (
    <LoadingIndicator />
  ) : (
    <PropertyMappings
      settingName={featureLine?.name}
      templateId={featureLine?.configuration.template.id}
      featureClassId={featureLine?.arcgisFeatureClass.id}
      featureTypeCategoryName={Civil3dFeatureTypeCategory.FEATURE_LINE}
      propertyMappings={propertyMappings}
      onSave={async ({ propertyMappings: propertyMappingsToSave }) => {
        await updatePropertyMappings({
          featureLineId: Number(featureLineId),
          propertyMappings: propertyMappingsToSave.filter(({ attributeId }) => Boolean(attributeId)),
        });
        navigate('..');
      }}
    ></PropertyMappings>
  );
};
